"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _InlineSvg = _interopRequireDefault(require("../../../../components/InlineSvg"));

var _ActiveSegmentPanel = _interopRequireDefault(require("./ActiveSegmentPanel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ActiveSegmentList = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ActiveSegmentList, _React$Component);

  function ActiveSegmentList(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "setActivePersona", function (id) {
      _this.setState(_extends({}, _this.state, {
        activePersona: id
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "removeClick", function (persona) {
      _this.props.removePersona(persona);

      var remainingPersonas = _this.props.personas.filter(function (item) {
        return item.id !== persona.id;
      });

      if (_this.state.activePersona === persona.id) {
        if (remainingPersonas.length) {
          _this.setState({
            activePersona: remainingPersonas[0].id
          });
        } else {
          _this.setState({
            activePersona: undefined
          });
        }
      }
    });

    _this.state = {
      activePersona: _this.props.personas.length > 0 && _this.props.personas[0].id ? _this.props.personas[0].id : undefined
    };
    return _this;
  } // num or string


  var _proto = ActiveSegmentList.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this2 = this;

    // If we previously never had personas, set the first persona as the active one
    if (prevProps.personas.length === 0 && this.props.personas.length > 0) {
      this.setState(_extends({}, this.state, {
        activePersona: this.props.personas[0].id
      }));
    } // If we have an active persona and that persona still exists, do nothing


    if (this.state.activePersona && this.props.personas.filter(function (item) {
      return item.id === _this2.state.activePersona;
    }).length) {
      return; // If we have an active persona and there's personas available
    } else if (this.state.activePersona && this.props.personas.length) {
      this.setState(_extends({}, this.state, {
        activePersona: this.props.personas[0].id
      }));
    }
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        personas = _this$props.personas,
        superSegments = _this$props.superSegments;
    var activePersona = this.state.activePersona;
    return /*#__PURE__*/React.createElement("div", {
      className: "active-persona-list"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "active-persona-list__title"
    }, "Personas"), /*#__PURE__*/React.createElement("div", {
      className: "active-persona-list__items"
    }, /*#__PURE__*/React.createElement("div", {
      className: "active-persona-list__personas"
    }, /*#__PURE__*/React.createElement("hr", {
      className: "active-persona-list__ruler"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "active-persona-list__personas-list"
    }, personas && personas.length ? personas.map(function (persona, key) {
      return /*#__PURE__*/React.createElement("li", {
        key: key,
        className: "active-persona-list__persona " + (activePersona === persona.id ? 'active' : '')
      }, /*#__PURE__*/React.createElement("button", {
        className: "active-persona-list__close-button",
        onClick: function onClick() {
          return _this3.removeClick(persona);
        }
      }, /*#__PURE__*/React.createElement(_InlineSvg["default"], {
        className: "active-persona-list__close-icon",
        colour: "paleSky",
        name: "close"
      })), /*#__PURE__*/React.createElement("button", {
        className: "active-persona-list__active-button",
        onClick: function onClick() {
          return _this3.setActivePersona(persona.id);
        }
      }, persona.id, " ", persona.name));
    }) : 'Select some personas to get started.')), /*#__PURE__*/React.createElement("div", {
      className: "active-persona-list__info-wrapper"
    }, superSegments && activePersona && personas && personas.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "active-persona-list__info-panel"
    }, activePersona && superSegments[parseInt(Math.floor(parseInt(activePersona) / 100) * 100)] ? /*#__PURE__*/React.createElement(_ActiveSegmentPanel["default"], {
      superSegment: superSegments[parseInt(Math.floor(parseInt(activePersona) / 100) * 100)],
      persona: activePersona
    }) : 'No active persona'))));
  };

  return ActiveSegmentList;
}(React.Component);

var _default = ActiveSegmentList;
exports["default"] = _default;